import * as React from "react";
import { BASE_URL } from "../../services/api";
import { useSelector } from "react-redux";
import InvoiceLineItems from "../InvoiceLineItems";
import useInvoice from "../../hooks/useInvoice";
import { useParams } from "react-router";

const ManageInvoiceLineItems = () => {
  const { id, invoiceId } = useParams()
  const [invoiceRecord, setInvoiceRecord] = React.useState({});
  const { detail } = useInvoice({ id, invoiceId });
  React.useEffect(() => {
    if (Object.keys(detail || {}).length > 0) {
      setInvoiceRecord(detail)
    }
  }, [detail, id, invoiceId])
  const { token } = useSelector((store) => store.auth);
  const onDownLoadClick = async (record) => {
    let result = await fetch(
      `${BASE_URL}/api/Reports/${id}/Invoices/${record.id}/DownloadInvoice`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    var link = document.createElement("a");
    const blob = await result.blob();
    const href = window.URL.createObjectURL(blob);
    link.download = `Invoice_${record.type ? record.id : record.invoiceNumber}`;
    link.href = href;
    link.click();
  };
  const onPaymentClick = async (record) => {
    localStorage.setItem("InvoicePayInfo", JSON.stringify({
      CCY: record.ccy,
      InvAmount: record.amount_Undispute,
      InvoiceNum: record.invoiceNumber,
      InvoiceId: record.id
    }));
    window.open(`${redirectUri}/invoicepayment/${record.id}`, "_blank");
  };
  const handleSuccess = (inv) => {
    if (inv) {
      handleChangeValue(inv.id, "amount_Dispute", inv.amount_Dispute);
    }
  };

  return (
    <div>
      {Object.keys(invoiceRecord || {}).length > 0 && <InvoiceLineItems isRoute
        invoiceRecord={invoiceRecord}
        setInvoiceRecord={setInvoiceRecord}
        onDownLoadClick={onDownLoadClick}
        onPaymentClick={onPaymentClick} />}
    </div>
  );
};

export default ManageInvoiceLineItems;
